import {
  DATA_CONNECTOR_GET_COLLECTIONS_FOR_SALESFORCE_BEGIN,
  DATA_CONNECTOR_GET_COLLECTIONS_FOR_SALESFORCE_SUCCESS,
  DATA_CONNECTOR_GET_COLLECTIONS_FOR_SALESFORCE_FAILURE,
  DATA_CONNECTOR_GET_COLLECTIONS_FOR_SALESFORCE_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { toast } from 'react-toastify';
export function getCollectionsForSalesforce(args = {}) {
  return (dispatch) => {
    dispatch({
      type: DATA_CONNECTOR_GET_COLLECTIONS_FOR_SALESFORCE_BEGIN,
    });
    const { projectId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/salesforce/get-collections`,
        args,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: DATA_CONNECTOR_GET_COLLECTIONS_FOR_SALESFORCE_SUCCESS,
            data: res.data,
          });
          resolve(res.data);
        },
        (err) => {
          toast.error(`Failed: Please Check your Credentials !`, {});
          dispatch({
            type: DATA_CONNECTOR_GET_COLLECTIONS_FOR_SALESFORCE_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissGetCollectionsForSalesforceError() {
  return {
    type: DATA_CONNECTOR_GET_COLLECTIONS_FOR_SALESFORCE_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case DATA_CONNECTOR_GET_COLLECTIONS_FOR_SALESFORCE_BEGIN:
      return {
        ...state,
        getCollectionsForSalesforcePending: true,
        getCollectionsForSalesforceError: null,
      };

    case DATA_CONNECTOR_GET_COLLECTIONS_FOR_SALESFORCE_SUCCESS:
      return {
        ...state,
        getCollectionsForSalesforcePending: false,
        getCollectionsForSalesforceError: null,
        salesforceCollections: action.data,
      };

    case DATA_CONNECTOR_GET_COLLECTIONS_FOR_SALESFORCE_FAILURE:
      return {
        ...state,
        getCollectionsForSalesforcePending: false,
        getCollectionsForSalesforceError: action.data.error,
      };

    case DATA_CONNECTOR_GET_COLLECTIONS_FOR_SALESFORCE_DISMISS_ERROR:
      return {
        ...state,
        getCollectionsForSalesforceError: null,
      };

    default:
      return state;
  }
}
